import React from 'react';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import { DateText, ItemBrand, ItemName, Title } from '@/components/atoms/Sidebar';
import { buildImageUrl } from '@/utilities/image';
import styles from './Item.module.scss';

const View: React.FC<{
  withBorder?: boolean;
  active?: boolean;
  onClick?: () => void;
  productId: number;
  productName: string | null;
  brandName: string;
  soldDate?: string | null;
  imageUrl: string;
}> = ({ withBorder, active, onClick, productId, productName, brandName, soldDate, imageUrl }) => {
  const { t } = useTranslation();
  const className = clsx(
    styles.container,
    withBorder ? styles.withBorder : '',
    active ? styles.active : '',
    onClick != null ? styles.clickable : '',
  );

  return (
    <button
      className={className}
      onClick={onClick}
      data-cy={`SideBar-itemCard__${productId}`}
    >
      <Title label={`${t('sidebar.item')} #${productId}`} />
      <div className={styles.product}>
        <img
          src={buildImageUrl(imageUrl)}
          alt={productName || '-'}
          className={styles.image}
        />
        <div className={styles.info}>
          <ItemBrand label={brandName} />
          <ItemName label={productName || '-'} />
        </div>
      </div>
      {soldDate && <DateText label={soldDate} />}
    </button>
  );
};

export default View;
